import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { handleIntent } from 'Store/intent/actions';
import { getUrlSearch } from 'Store/routing/selectors';

const useDeeplinkIntent = () => {
  const dispatch = useDispatch();
  const urlSearch = useSelector(getUrlSearch);

  useEffect(() => {
    if (urlSearch?.includes('intent')) {
      const query = new URLSearchParams(urlSearch);
      const intent = query.get('intent');
      if (intent) {
        dispatch(handleIntent(intent, { fromUserAction: false }));
      }
    }
  }, [urlSearch, dispatch]);
};

export default useDeeplinkIntent;
